import { call } from '@advanza/api'
import { ScheduledTermination } from 'interfaces/ScheduledTermination'

export const scheduleTermination = (
    providerId: number,
    reason: number,
    explanation: string | null,
    terminationDate: string,
): Promise<{ scheduledTermination: ScheduledTermination }> =>
    call(`office/scheduled-terminations/schedule/${providerId}`, {
        json: { reason, explanation, termination_date: terminationDate },
    })

export const cancelScheduledTermination = (
    providerId: number,
): Promise<{ scheduledTermination: ScheduledTermination }> =>
    call(`office/scheduled-terminations/cancel-schedule/${providerId}`, { method: 'post' })
